<template>
  <div class="pcHome">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/pc/base/heard.vue";
import Footer from "@/components/pc/base/footer.vue";
import { addVisits } from "@/api/api.js";

export default {
  name: "pcHome",
  components: {
    Header,
    Footer
  },
  mounted() {
    this.addVisits();
  },
  methods: {
    addVisits() {
      addVisits().then(() => {
        // console.log(res, 'res=========================');
      });
    }
  }
};
</script>

<style lang="less">
.pcHome {
  width: 100%;
  min-width: 1200px;
}
.t-c {
  width: 100%;
  text-align: center;
}
</style>
